<template>
    <div class="bg-white border">
        <div class="d-flex h-100 flex-column">
            <div class="p-3 border  border-left-0 border-right-0">
                <button class="addSlideBtn btn" @click="createCanvas">Add Slide <i class="fas fa-plus"></i></button>
            </div>
            <div class="d-flex h-0 overflow-y-auto flex-grow-1 overflow-x-hidden">
                <ul class="m-0 my-3 p-0">
                    <li :class="`mb-3 list-unstyled slidelistitems ${index == activeIndex ? 'active' : ''}`"
                        v-for="(item, index) of CanvasHtml" v-bind:key="index">
                        <div class="d-flex align-items-center">
                            <div class="slideNum p-2">{{ index + 1 }}</div>
                            <div class="slideImg" @click="setActiveIndex(index)">
                                <div class="slideImg_duration">{{ formattedDuration(item.slideDuration) }}</div>
                            </div>
                            <div class="dotsimg">
                                <b-dropdown id="dropdown-2" class="m-0" variant="link"
                                    toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 4" class="rotate-90">
                                            <circle cx="2" cy="2" r="2"></circle>
                                            <circle cx="10" cy="2" r="2"></circle>
                                            <circle cx="18" cy="2" r="2"></circle>
                                        </svg>
                                    </template>
                                    <b-dropdown-item @click="duplicateCanvasInstance(index)">Duplicate</b-dropdown-item>
                                    <b-dropdown-item @click="removeCanvas(item.id)">Remove</b-dropdown-item>
                                    <b-dropdown-item @click="$bvModal.show('SlideDuration-Model')">Slide
                                        Duration</b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>


        <b-modal id="SlideDuration-Model" hide-header>
            <!-- <template #modal-title>
      Using <code>$bvModal</code> Methods
    </template> -->
            <div class="d-block text-center">
                <h4 class="text-center mb-3">Slide Duration</h4>
                <div>
                    <label class="duration" for="input-live">Slide Duration:</label>
                    <b-form-input type="number" placeholder="Duration" :value="canvasDuration"
                        @change="setCanvasDuration($event)"></b-form-input>
                </div>
            </div>
            <template #modal-footer>

                <button class="btn btn-secondary" @click="$bvModal.hide('SlideDuration-Model')">Cancel</button>
                <button class="btn btn-primary" @click="saveAndCloseModal()">Save</button>

            </template>
        </b-modal>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { getResolutionScaleValue } from "../common";

export default {
    name: 'SlidesPanel',
    data() {
        return {
            activeIndex: 0,
            canvasDuration: 0
        }
    },
    mounted() {
        this.canvasDuration = this.activeSlideDuration.slideDuration;
    },
    computed: {
        CanvasHtml() {
            return this.$store.getters.getCanvasInstances
        },

        activeSlideDuration() {
            return this.$store.getters.getCurrentActiveCanvas
        }
    },
    watch: {
        "$store.state.canvasRefs": {
            handler(newValue, oldValue) {
                // Note: `newValue` will be equal to `oldValue` here
                // on nested mutations as long as the object itself
                // hasn't been replaced.
                this.$store.dispatch("createNewCanvas");

                console.log(newValue, oldValue)
            },
            deep: true
        },


    },
    methods: {
        createCanvas() {
            debugger // eslint-disable-line no-debugger

            this.$store.dispatch("setCanvasInstance",
                {
                    id: `canvas_${uuidv4()}`,
                    size: {
                        width: 1920,
                        height: 1080
                    },
                    zoomRatio: 1,
                    bgColor: "#fff",
                    slideDuration: 20,
                    objects: []
                }
            );
            console.log(this.CanvasHtml)

            this.setActiveIndex(this.CanvasHtml?.length - 1);
            this.setCurrentTargetnull();
            this.$store.dispatch("setZoom", getResolutionScaleValue(1920, 1080))

        },
        setActiveIndex(value) {
            this.activeIndex = value;
            this.$store.dispatch("setActiveCanvasIndex", value);
            this.setCurrentTargetnull();
        },
        duplicateCanvasInstance(index) {
            let objtoduplicate = this.CanvasHtml[index];
            let newobjArray = objtoduplicate.objects.map(x => {
                return {
                    ...x,
                    id: `${x.id.split("_")[0]}_${uuidv4()}`
                }
            });

            let newObj = {
                id: `canvas_${uuidv4()}`,
                size: {
                    width: objtoduplicate.size.width,
                    height: objtoduplicate.size.height
                },
                zoomRatio: objtoduplicate.zoomRatio,
                bgColor: "#fff",
                objects: newobjArray
            }



            let obj = { index: index, newObj }
            this.$store.dispatch("duplicateCanvas", obj)
            this.setActiveIndex(index + 1);
            this.setCurrentTargetnull();
        },
        removeCanvas(id) {
            this.$store.dispatch("removeCanvas", id)
            this.setActiveIndex(0)
            this.$store.dispatch("setActiveCanvasIndex", 0)
            this.setCurrentTargetnull();

        },
        setCurrentTargetnull() {
            this.$store.dispatch("setActiveObject", null)
        },

        formattedDuration(duration) {
            debugger // eslint-disable-line no-debugger
            const totalSeconds = Number(duration);
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        },
        setCanvasDuration(e) {
            debugger // eslint-disable-line no-debugger
            this.canvasDuration = e;
        },
        saveAndCloseModal() {
            this.setDurationInStore();
            this.$bvModal.hide('SlideDuration-Model');
        },
        setDurationInStore() {
            debugger // eslint-disable-line no-debugger
            console.log(this.canvasDuration);
            this.$store.dispatch('setSlideDuration', this.canvasDuration);
        }

    }
}
</script>

<style scoped>
.slideImg {
    border: 5px solid #ccc;
    border-radius: 5px;
    height: 50px;
    width: 105px;
    cursor: pointer;
    display: flex;
    justify-content: end;
    align-items: end;
}

.slideImg_duration {
    padding: 0px 4px;
    margin: 0 5px 5px 0;
    background: rgb(0 0 0 / 40%);
    color: white;
    font-size: 8px;
    font-weight: bold;
    width: fit-content;
    border-radius: 4px;
}

.rotate-90 {
    transform: rotate(90deg)
}

.slidelistitems.active .slideImg {
    border-color: #8e42ff;
}

.dotsimg {
    width: 1rem;
}

.overflow-x-hidden {
    overflow-x: hidden;
}

.overflow-y-auto {
    overflow-y: auto;
}

.h-0 {
    height: 0;
}

.addSlideBtn {
    font-weight: 700;
    font-size: .875rem;
    line-height: 1.5rem;
    padding-left: .95rem;
    padding-right: .95rem;
    padding-bottom: .5rem;
    padding-top: .5rem;
    border-radius: .25rem;
    width: 100%;
    display: inline-block;
    background-color: rgb(248 249 250);
    border-color: rgb(221 226 229);
    border-width: 1.5px;
    color: rgb(73 80 87);
}

.duration {
    margin-left: -23rem;
}
</style>